import React from 'react';
import { observer } from 'mobx-react';
import Box from '@mui/material/Box';
import HeaderContainer from '@ui/features/Header/Header.container';
import HistoryMenuContainer from '@ui/features/History-menu/History-menu.container';
import MainContainer from '@ui/features/Main/Main.container';
import DeviceTelemetryContainer from '@ui/features/Device-telemetry/Device-telemetry.container';
import withPage from '@ui/HOCs/withPage';
import withSideBar from '@ui/HOCs/withSideBar';
import withSection from '@ui/HOCs/withSection';
import withSections from '@ui/HOCs/withSections';
import { lang } from '@lang/interfaces/lang';

interface IProps extends JSX.IntrinsicAttributes {
    lang: lang;
}

const SideBar = withSideBar(HistoryMenuContainer);
const Map = withSection(MainContainer);
const DeviceTelemetry = withSection(DeviceTelemetryContainer);
const SectionsContent: React.FC<IProps> = () => {
    return (
        <>
            <Map />
            <DeviceTelemetry />
        </>
    );
};
const Sections = withSections(SectionsContent);

const Page: React.FC<IProps> = ({ lang }: IProps) => {
    return (
        <>
            <HeaderContainer />
            <Box className="main" component="main">
                <SideBar />
                <Sections lang={lang} />
            </Box>
        </>
    );
};

const WrappedPage = withPage(Page, 'main__wrap', 'locationHistory');

const HistoryPage = observer(WrappedPage);

export default HistoryPage;
